export const colMappingForm = 'csvImportColumnMappingForm';
